'use client';

import Link from 'next/link';
import { ArrowRight, Smartphone } from 'lucide-react';
import { PublicSection } from '../../../../components/public/PublicSection';
import { ANDROID_DOWNLOAD_URL, ANDROID_WEBSITE_DOWNLOAD_URL, APPLE_APP_STORE_URL, PROJECT_NAME } from '@shared/constants';

/**
 * @group Landing
 * @summary Closing section with final CTA and tagline
 */
export function ClosingSection() {
  return (
    <PublicSection inverted className="text-center" id="products" indented={false}>
      <div className="max-w-4xl mx-auto">
        <h2 className="text-4xl sm:text-5xl font-bold mb-6">
          Live Well, Anywhere
        </h2>
        <p className="text-lg mb-4 leading-relaxed opacity-95">
          Quality healthcare shouldn't depend on where you live, how much you earn, or whether you can take a day off work. {PROJECT_NAME} exists to make excellent medical care accessible to every South African, delivered with dignity and respect.
        </p>
        <p className="text-lg mb-8 italic opacity-90">
          "Phila" means "to live" or "to be well". It's a promise we make to every patient: you deserve to live well, with access to healthcare that respects your time, your circumstances, and your humanity.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <Link
            href="/users/signup"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-background text-primary rounded-lg font-semibold hover:bg-muted transition-colors"
          >
            Book a Consult <ArrowRight className="w-5 h-5" />
          </Link>
          <Link
            href={APPLE_APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 border-2 border-white text-white rounded-lg font-semibold hover:bg-white/10 transition-colors"
          >
            <Smartphone className="w-5 h-5" />
            App Store
          </Link>
          <Link
            href={ANDROID_WEBSITE_DOWNLOAD_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 border-2 border-white text-white rounded-lg font-semibold hover:bg-white/10 transition-colors"
          >
            <Smartphone className="w-5 h-5" />
            Android
          </Link>
        </div>

        <p className="text-lg font-semibold opacity-95">
          On your schedule. Quality care in your pocket.
        </p>
      </div>
    </PublicSection>
  );
}
